import { Settings } from '@ecm/config/Settings'
import { Author } from '@ecm/data/Author'
import { runEff } from '@ecm/effect'
import AuthorArticlesList, {
  AuthorArticlesListProps,
} from '@ecm/ui/component/blog/AuthorArticlesList'
import { BreadCrumb } from '@ecm/ui/element/Breadcrumbs'

export const AuthorHomePage = ({
  author,
  authorId,
  currentPage,
  totalPages,
  breadCrumb,
  className,
  articles,
}: AuthorArticlesListProps) => {
  return (
    <AuthorArticlesList
      author={author}
      authorId={authorId}
      currentPage={currentPage}
      totalPages={totalPages}
      breadCrumb={breadCrumb}
      className={className}
      articles={articles}
    />
  )
}

export default AuthorHomePage

export const getStaticProps = async (ctx: { params: { id: string } }) => {
  const authorId = ctx.params?.id

  const defaultAuthor = {
    fullname: 'Earth Class Mail Team',
  }

  const articlesByAuthor = await runEff(async eff => {
    if (!authorId) {
      return null
    }
    try {
      return await eff.getPaginatedArticlesById(authorId, 1)
    } catch (e) {
      return null
    }
  })
  if (!articlesByAuthor) {
    return {
      props: {
        articles: [],
        author: defaultAuthor,
        totalPages: 0,
      },
    }
  }

  const breadCrumb: BreadCrumb[] = [
    { description: 'Blog', href: '/blog', position: 2 },
    {
      description: articlesByAuthor.items.length
        ? articlesByAuthor.items[0].author.fullname
        : 'EarthClassMail',
      href: `/blog/${authorId}`,
      position: 3,
    },
  ]
  const totalPages = Math.ceil(articlesByAuthor.total / Settings.pagination.pageSize)

  return {
    props: {
      articles: articlesByAuthor.items,
      author: articlesByAuthor.items.length ? articlesByAuthor.items[0].author : defaultAuthor,
      authorId,
      breadCrumb,
      currentPage: 1,
      totalPages: totalPages,
    },
  }
}

export async function getStaticPaths() {
  const authors: Author[] = await runEff(eff => eff.getAuthors())
  const paths = authors.map(c => ({ params: { id: c.id } }))

  return {
    fallback: false,
    paths,
  }
}
